


export const getMatchWords = (
  {
    word,
    text
  }
) => {
  const re = new RegExp(word, 'gi');
  const finalResult = [];
  const result = re.exec(text);
  if (!result) {
    return [{value: text, match: false}];
  }
  const wordLength = word.length;
  let startIndex = 0;
  const targetIndex = result.index;
  let endIndex = targetIndex + wordLength;
  console.log(targetIndex, 'TARGET INDEX');
  console.log(endIndex, 'END INDEX');
  if (targetIndex !== startIndex) {
    const falseValue = text.slice(startIndex, targetIndex);
    const trueValue = text.slice(targetIndex, endIndex);
    console.log(falseValue, 'FALSE VALUE');
    console.log(trueValue, 'TRUE VALUE');
    finalResult.push({
      value: falseValue,
      match: false
    });
    finalResult.push({
      value: trueValue,
      match: true
    });
    startIndex = endIndex;
  } else {
    finalResult.push({
      value: text.slice(targetIndex, endIndex),
      match: true
    });
    startIndex = endIndex;
  }

  while(true) {
    const result = re.exec(text);
    console.log(text, 'TEXT---');
    console.log(result, 'RESULT');
    if (!result) {
      const value = text.slice(startIndex, text.length);
      finalResult.push({
        value,
        match: false
      });
      break;
    }
    const targetIndex = result.index;
    let endIndex = targetIndex + wordLength;

    if (targetIndex !== startIndex) {
      const falseValue = text.slice(startIndex, targetIndex);
      const trueValue = text.slice(targetIndex, endIndex);
      console.log(falseValue, 'FALSE VALUE');
      console.log(trueValue, 'TRUE VALUE');
      finalResult.push({
        value: falseValue,
        match: false
      });
      finalResult.push({
        value: trueValue,
        match: true
      });
      startIndex = endIndex;
    } else {
      finalResult.push({
        value: text.slice(targetIndex, endIndex),
        match: true
      });
      startIndex = endIndex;
    }
  }
  let finalString = "<p>";
  finalResult.forEach(d => {
    if (!d.match) {
      finalString += d.value;
    } else {
      finalString += `<mark>${d.value}</mark>`
    }
  });
  finalString += "</p>"
  return finalString;
};



// WEBPACK FOOTER //
// ./src/components/list/getMatchWords.js